// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"129":"8bfe5fbe5324f4af","253":"16968ae8e6701b3c"}[chunkId] + ".js";
};